import { render, staticRenderFns } from "./PdfReminderForm.vue?vue&type=template&id=c828cf9c&scoped=true"
import script from "./PdfReminderForm.vue?vue&type=script&lang=js"
export * from "./PdfReminderForm.vue?vue&type=script&lang=js"
import style0 from "./PdfReminderForm.vue?vue&type=style&index=0&id=c828cf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c828cf9c",
  null
  
)

export default component.exports